export const shortTerm = [
  {
    icon: "🏠",
    title: "Full Property Onboarding",
    subtitle: "From Empty to Earning.",
    description: "We take care of furnishing, styling, and utility setups – your home becomes guest-ready without lifting a finger.",
  },
  {
    icon: "📸",
    title: "Stunning Visuals That Sell",
    subtitle: "First Impressions Matter.",
    description: "Professional photography and videography that grab attention and drive bookings across global platforms.",
  },
  {
    icon: "🌍",
    title: "Global Listing Exposure",
    subtitle: "List Once. Seen Everywhere.",
    description: "We showcase your property on Airbnb, Booking.com, Expedia, and more—maximizing reach and occupancy.",
  },
  {
    icon: "💰",
    title: "Smart Dynamic Pricing",
    subtitle: "Earn More, Every Night.",
    description: "Our pricing engine adapts to seasons, demand, and local events to maximize your income—all automatically.",
  },
  {
    icon: "🛎️",
    title: "24/7 Guest Management",
    subtitle: "Always Available, So You Don’t Have to Be.",
    description: "We handle all guest communication—from pre-check-in questions to late-night emergencies.",
  },
  {
    icon: "🧼",
    title: "Hotel-Level Cleaning",
    subtitle: "Five-Star Clean, Every Time.",
    description: "Deep-cleaning after each guest with fresh linens and high-quality amenities included.",
  },
  {
    icon: "🧺",
    title: "Luxury Linen & Essentials",
    subtitle: "Comfort That Impresses.",
    description: "Crisp sheets, plush towels, and premium toiletries provided with every stay—because details matter.",
  },
  {
    icon: "🛠️",
    title: "Full Maintenance Coverage",
    subtitle: "We Fix It Before They Notice.",
    description: "From AC issues to minor repairs, our team ensures your property stays flawless 24/7.",
  },
  {
    icon: "📊",
    title: "Live Owner Dashboard",
    subtitle: "Your Property. Your Control.",
    description: "Track bookings, earnings, and guest reviews in real-time with your personalized owner portal.",
  },
  {
    icon: "💸",
    title: "Monthly Payouts, Hassle-Free",
    subtitle: "You Earn, We Handle the Rest.",
    description: "Transparent monthly statements and automated payouts straight to your account.",
  },
  {
    icon: "🔐",
    title: "Verified Guests Only",
    subtitle: "We Protect What’s Yours.",
    description: "Strict screening, ID verification, and damage deposit policies to keep your property safe.",
  },
  {
    icon: "🏢",
    title: "DTCM Compliance Included",
    subtitle: "100% Legal. 100% Stress-Free.",
    description: "We handle all Dubai Tourism (DTCM) permits and ensure full legal compliance—no surprises, just success.",
  },
];


export const legalServices = [
  {
    icon: "🛡️",
    title: "Legal Services for Real Estate Clients",
    description:
      "At Embark Properties, we provide comprehensive legal support for real estate investors, homeowners, and developers across Dubai. Our services include:",
  },
  {
    icon: "✅",
    title: "Property Title Verification",
    description: "Ensure legal ownership and clear title before any transaction.",
  },
  {
    icon: "✅",
    title: "Sales & Purchase Agreement (SPA) Drafting & Review",
    description: "Legally sound contracts tailored to protect your interests.",
  },
  {
    icon: "✅",
    title: "Tenancy Contract & MOU Drafting",
    description: "Accurate, enforceable documents aligned with RERA regulations.",
  },
  {
    icon: "✅",
    title: "Ejari Registration Support",
    description: "Fast and compliant registration with the Dubai Land Department.",
  },
  {
    icon: "✅",
    title: "Due Diligence (Off-Plan & Ready Properties)",
    description:
      "Thorough checks on developers, project status, and legal standing.",
  },
  {
    icon: "✅",
    title: "Ownership Transfer Management",
    description: "Seamless handling of all DLD processes and documentation.",
  },
  {
    icon: "✅",
    title: "Dispute Resolution Assistance",
    description:
      "Professional support for resolving property or rental disputes.",
  },
  {
    icon: "✅",
    title: "DLD & Legal Compliance Advisory",
    description:
      "Stay fully compliant with all UAE real estate laws and regulatory frameworks.",
  },
];

export const happyClients = [
  {
    icon: "🎉",
    title: "10,000+ Happy Clients & Counting!",
    description: "Welcome to Embark Properties — Dubai’s trusted real estate partner.",
  },
  {
    icon: "🏡",
    title: "Property Buying & Selling",
    description: "Helping you buy or sell properties with expert guidance.",
  },
  {
    icon: "💸",
    title: "Mortgage Assistance",
    description: "Get the best home loan deals in Dubai.",
  },
  {
    icon: "🧠",
    title: "Expert Investment Consulting",
    description: "Tailored investment plans with high ROI.",
  },
  {
    icon: "📜",
    title: "Legal & Documentation Support",
    description: "MOUs, SPA, Ejari & more, handled for you.",
  },
  {
    icon: "🏢",
    title: "Commercial & Residential Properties",
    description: "Wide portfolio of properties to choose from.",
  },
  {
    icon: "🔑",
    title: "Rental Services",
    description: "Long-term rentals and holiday home management.",
  },
  {
    icon: "🇦🇪",
    title: "Golden Visa Guidance",
    description: "Property-linked residency solutions in the UAE.",
  },
  {
    icon: "✅",
    title: "Trusted Team",
    description: "Work with experienced real estate professionals.",
  },
  {
    icon: "✅",
    title: "Fast & Transparent Process",
    description: "We ensure efficiency and full clarity in every step.",
  },
  {
    icon: "✅",
    title: "End-to-End Property Solutions",
    description: "From search to sale — we handle everything.",
  },
  {
    icon: "📩",
    title: "Get Free Consultation Today!",
    description: "Let us help you make the smartest move in Dubai real estate.",
  },
];
